module.exports = __webpack_public_path__ + "img/plus.b4586f4f.png";